<div [ngClass]="'form-group--' + config.displayType" *ngIf="config.options.length > 1">
  <ng-container [ngSwitch]="config.displayType">
    <ng-container *ngSwitchCase="radioDisplayType.list">
      <ng-container *ngFor="let opt of config.options">
        <div class="option" [class.selected]="group.get(config.name)?.value === opt.value">
          <ng-container [ngTemplateOutlet]="radioButton" [ngTemplateOutletContext]="{ $implicit: opt }"></ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngFor="let opt of config.options">
        <ng-container [ngTemplateOutlet]="radioButton" [ngTemplateOutletContext]="{ $implicit: opt }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<ng-template #radioButton let-opt [formGroup]="group">
  <input
    [id]="config.name + '_' + opt.value"
    type="radio"
    [value]="opt.value"
    [name]="config.name"
    [formControlName]="config.name"
    [checked]="opt.selected || config.value === opt.value"
    (change)="onChange()"
  />
  <label
    [for]="config.name + '_' + opt.value"
    [style.background-color]="config.color && (opt.selected || formControl?.value === opt.value) && '#' + config.color.color"
    [style.color]="config.color && !opt.selected && formControl?.value !== opt.value && '#' + config.color.color"
    [style.box-shadow]="config.color && 'inset 0px 0px 0px 2px #' + config.color.color"
  >
    {{ opt.text }}
  </label>
</ng-template>
